import React from 'react';
import EntityManagementPage, { EntityField } from './EntityManagementPage';
import { useAppSelector } from '../../store/hooks';
import { createAllergen, deleteAllergen, fetchAllergens, updateAllergen } from '../../store/slices/allergenSlice';
import { Allergen } from '../../types';

const fields: EntityField[] = [
  { key: 'name', label: 'Назва', required: true },
  { key: 'description', label: 'Опис', type: 'textarea' },
];

const AllergensPage: React.FC = () => {
  const state = useAppSelector((s) => s.allergen);
  return (
    <EntityManagementPage<Allergen>
      title="Управління алергенами"
      items={state.items}
      loading={state.loading}
      submitting={false}
      error={null}
      fields={fields}
      fetchAll={fetchAllergens}
      createItem={createAllergen}
      updateItem={updateAllergen}
      deleteItem={deleteAllergen}
    />
  );
};

export default AllergensPage;
